function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { createContext } from 'react';
import { default as MuiCard } from '@material-ui/core/Card';
import { default as withStyles } from '../styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { borderRadiusMedium, sizingSmall } from '../styles/tokens';

var styles = function styles(theme) {
    return {
        root: {
            borderRadius: borderRadiusMedium,
            overflow: 'inherit'
        },
        accent: {
            borderTopWidth: sizingSmall,
            borderTopStyle: 'solid',
            paddingTop: 0
        },
        accentPrimary: {
            borderTopColor: theme.palette.primary.main
        },
        accentSecondary: {
            borderTopColor: theme.palette.secondary.main
        }
    };
};

var CardContext = createContext();

/**
 * Use `Card` to display a group of similar content on a page.
 * @done true
 * @updated false
 * @versionAdded v0.0.3
 * @examples
 *  SimpleCard
 *  VisuallyAccentedCard
 *  ComplexCard
 *  CommunicationHistory
 */
var Card = React.forwardRef(function (props, ref) {
    var _classNames;

    var accent = props.accent,
        classes = props.classes,
        padding = props.padding,
        responsive = props.responsive,
        rest = _objectWithoutProperties(props, ['accent', 'classes', 'padding', 'responsive']);

    var classOverrides = classNames(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.accent, ['primary', 'secondary'].indexOf(accent) !== -1), _defineProperty(_classNames, classes.accentPrimary, accent === 'primary'), _defineProperty(_classNames, classes.accentSecondary, accent === 'secondary'), _classNames));

    return React.createElement(
        CardContext.Provider,
        {
            value: {
                padding: padding,
                responsive: responsive
            }
        },
        React.createElement(MuiCard, Object.assign({}, rest, {
            classes: {
                root: classOverrides
            },
            ref: ref
        }))
    );
});

Card.muiName = 'Card';
Card.displayName = 'Card';

Card.propTypes = {
    /**
     * Customize the color of accent border that is added to the card.
     * The options are `primary` and `secondary`. The `Card` will render with an
     * accented top border color that corresponds to the theme's primary and secondary
     * color (i.e. `primary` will render a `Card` with a `primary` accent border).
     */
    accent: PropTypes.oneOf(['primary', 'secondary']),
    /**
     * If `true`, the card will use raised visual styling
     */
    raised: PropTypes.bool,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object.isRequired,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    elevation: PropTypes.number,
    /**
     * Customize the spacing for Card's subcomponents. Standard, dense, and none
     * apply consistent padding across all viewports, per subcomponent.
     */
    padding: PropTypes.oneOf(['standard', 'dense', 'none']),
    /**
     * If `true`, `responsive` combines with `padding` to provide a responsive
     * spacing solution, if padding is set to either `standard` or `dense`.
     */
    responsive: PropTypes.bool

};

Card.defaultProps = {
    elevation: 5,
    padding: 'standard',
    responsive: true
};

export { CardContext };
export default withStyles(styles)(Card);